import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { LETTER_FORMAT } from '../../utils/constants'
import Question from '../../models/question'
import { questionServiceParser } from '../../../../helpers/question-parser'
import Skill from '../../models/skill'
import SkillItem from '../../models/skill_item'
import map from 'lodash/map'
import markdownParser from '../../../../helpers/markdown-parser'
import { resetStyleMathLive, checkMathLiveExist, createMathliveField } from '../../../../lib/mathlive'
import { checkIOS } from '../../utils/utils'
import Exam from '../../models/exam'
import { processAudioSpeak } from '../../../../lib/speak_polly'
import * as AceEditor from 'brace'
import 'brace/mode/javascript';
import 'brace/mode/typescript';
import 'brace/mode/ruby';
import 'brace/mode/python';
import 'brace/mode/html';
import 'brace/mode/json';
import 'brace/mode/sql';
import 'brace/theme/monokai'


@Component
export default class ExamTestQuestionBodyMixin extends Vue {
  @Prop({ required: true }) exam: Exam
  @Prop({ required: true }) currentQuestion: Question
  @Prop({ required: true }) index: number
  @Prop({ required: true }) time: number
  markdownParser = markdownParser
  LETTER_FORMAT = LETTER_FORMAT
  value: string[] = []
  text: string = ''
  // Audioのため、mounted1/10秒のあとに、viewを実行します。やらないと、IOSで体重問題発生します。
  show = true

  get content(): string {
    if (!this.currentQuestion) {
      return ''
    }
    setTimeout(() => {
      if (this.currentQuestion.isTextfield) {
        (document
          .getElementById(`question_${this.currentQuestion.id}`)
          .querySelectorAll('.textfield-question') as any).forEach((element: HTMLInputElement, index) => {
          element.value = this.value[index] ? this.value[index] : ''
          const answerItem = this.currentQuestion.answerItems[index]
          if(checkMathLiveExist(answerItem.body)){
            createMathliveField(element)
          }
        })
      }
      if (this.currentQuestion.isInlineSelect) {
        (document
          .getElementById(`question_${this.currentQuestion.id}`)
          .querySelectorAll('.inline-select-question') as any).forEach((element: HTMLSelectElement, index) => {
          Array.prototype.forEach.call(element.options, (option: HTMLOptionElement) => {
            if (option.value == this.value[index]) {
              option.selected = true
            }
          })
        })
      }

      // Text - Speak 実行
      processAudioSpeak(document.getElementById(`question_${this.currentQuestion.id}`))

    }, 100)
    const content = this.currentQuestion.body.split('<a ').join('<a target="_blank" ')
    return questionServiceParser(content, this.currentQuestion, true)
  }

  get explanation(): string {
    if (!this.currentQuestion.explanation) {
      return ''
    }
    return markdownParser(this.currentQuestion.explanation)
  }

  @Watch('currentQuestion', {immediate: true})
  watchCurrentQuestion() {
    this.updateData()
  }

  emitChangeValue() {
    this.$emit('changeValue', this.value, this.currentQuestion)
  }

  mounted() {
    this.updateData()

    resetStyleMathLive()

    this.$nextTick(this.setupAceEditor)
  }

  textareaOnChange() {
    this.$emit('changeValue', [this.text], this.currentQuestion)
  }

  updateData() {
    const tmpText = localStorage.getItem(this.questionTemporaryAnswer)
    this.value = this.currentQuestion.answerValues
    if (tmpText) {
      const tmpText = localStorage.getItem(this.questionTemporaryAnswer)
      this.text = tmpText ? tmpText : ''
    } else if (this.value.length) {
      this.text = this.value[0]
    } else {
      this.text = ''
    }

    this.emitChangeValue()

    // Audioのため、mounted1/10秒のあとに、viewを実行します。やらないと、IOSで体重問題発生します。
    if (checkIOS()) {
      this.show = false
      setTimeout(() => {
        this.show = true
      }, 100)
    }
  }

  skillItemsName(skill: Skill): string {
    const skillItems = skill.skillItems.filter(skillItem =>
      this.currentQuestion.skillItems.some(item => item.id == skillItem.id)
    )
    return this.getSkillsName(skillItems)
  }

  getSkillsName(skills: Skill[] | SkillItem[]) {
    return map(skills, 'name').join(', ')
  }

  @Watch('text', {immediate: true})
  watchText() {
    localStorage.setItem(this.questionTemporaryAnswer, this.text)
  }

  callBackChange(value) {
    this.value = value
    this.emitChangeValue()
  }

  callBackChangeOne(a) {
    this.value = [a]
    this.emitChangeValue()
  }

  get questionTemporaryAnswer() {
    return `${this.exam.userExam.id}_temporary_q_${this.currentQuestion.id}_textarea`
  }

  getAnswerMode(): string {
    const match = this.currentQuestion.body.match(/code,\s?"?(\w+)"?]/)
    const code =  match ? match[1] : ''
    return code && ["html", "javascript", "typescript", "ruby", "python", "json", "sql"].includes(code.toLowerCase()) ? code : null
  }

  setupAceEditor() {
    const mode = this.getAnswerMode()
    if (!mode) return

    const editor = AceEditor.edit("editor")
    editor.getSession().setMode(`ace/mode/${mode}`);
    editor.setTheme('ace/theme/monokai')
    editor.setValue(this.text, 1)
    editor.setOptions({fontSize: "16px"})
    editor.on('change', (e) => {
      this.text = editor.getSession().getValue()
      this.$emit('changeValue', [this.text], this.currentQuestion)
    })
  }
}
